import getDefaultState from './defaultState';

export default getDefaultState();



// WEBPACK FOOTER //
// ./src/store/modules/affiliate/state.js